import { STORE_PERSONAL_LANGUAGE } from "../types";

export const storePersonalLanguage = (language) => (dispatch) => {
  dispatch({
    type: STORE_PERSONAL_LANGUAGE,
    payload: language,
  });
};
